import { Link } from "react-router-dom";
import emblem192 from "../assets/oakford-emblem-192.png";
import emblem480 from "../assets/oakford-emblem-480.png";
import emblem960 from "../assets/oakford-emblem-960.png";

const ALT = "Oakford Ledger emblem — OL monogram with oak leaf and acorn inside a double circular border";
const SRCSET = `${emblem192} 192w, ${emblem480} 480w, ${emblem960} 960w`;

// Approved emblem (navy linework, ivory lifted to transparency so it sits on any surface).
export const Emblem = ({ className = "", sizes = "48px", testId = "brand-emblem-img", eager = false }) => (
  <img
    src={emblem480}
    srcSet={SRCSET}
    sizes={sizes}
    alt={ALT}
    data-testid={testId}
    loading={eager ? "eager" : "lazy"}
    decoding="async"
    className={className}
  />
);

// Header brand: emblem + business name as live serif text; links home.
export const Wordmark = ({ tone = "dark", className = "" }) => {
  const color = tone === "light" ? "#F7F4EB" : "#0A1128";
  return (
    <Link to="/" className={`flex items-center gap-2 sm:gap-3 group ${className}`} data-testid="brand-logo" aria-label="Oakford Ledger home">
      <Emblem eager sizes="56px" testId="brand-logo-img" className="h-11 w-11 sm:h-14 sm:w-14 shrink-0 object-contain transition-transform duration-500 group-hover:scale-[1.04]" />
      <span className="font-serif text-[17px] sm:text-xl tracking-tight whitespace-nowrap" style={{ color, lineHeight: 1.05 }}>Oakford Ledger</span>
    </Link>
  );
};
